import { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VNProvinceList } from "./ProvinceList";
import { faHouse, faLocationDot } from "@fortawesome/free-solid-svg-icons";

const ShopList = ({ shops, onSelectShop }) => {
  const [provinceShop, setProvinceShop] = useState();

  const handleChange = (e) => {
    setProvinceShop(e.target.value);
  };
  return (
    <Fragment>
      <div>
        <label htmlFor="shops" className="text-success fw-bold fs-5 mb-1">
          Tìm đại lý của Mễ Mễ Việt Nam
        </label>
        <select
          className="form-select fw-bold text-muted"
          id="shops"
          onChange={handleChange}
        >
          <option value="">--Chọn khu vực của bạn--</option>
          {VNProvinceList.map((city, i) => (
            <option key={i} value={city}>
              {city}
            </option>
          ))}
        </select>
      </div>
      <div>
        {(!provinceShop
          ? shops
          : shops.filter((el) => el.province === provinceShop)
        ).map((shop, index) => (
          <div
            className="m-3"
            role="button"
            key={index}
            onClick={() => onSelectShop(shop)}
          >
            <h5 className="text-primary">
              <span>
                <FontAwesomeIcon icon={faHouse} className="text-warning me-2" />
              </span>
              {shop.name}
            </h5>
            <p>
              <span>
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="text-danger me-2"
                />
              </span>
              {shop.address}
            </p>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default ShopList;
